import { c as _c } from "react/compiler-runtime";
import type { Entry, UnresolvedLink } from 'contentful';
import { clsx } from '@libs/common-next';
import type { PageProps } from '@libs/core';
import { buildPage, isResolvedLinkEntry } from '../../utils';
function filterPLPItems(items: (Entry | UnresolvedLink<'Entry'>)[] = []) {
  return items.filter(entry => isResolvedLinkEntry(entry));
}
export function ProductListPage(t0) {
  const $ = _c(9);
  const {
    entry,
    placement
  } = t0;
  let t1;
  if ($[0] !== entry?.fields || $[1] !== placement) {
    const {
      items,
      bottomItems
    } = entry?.fields ?? {};
    const itemsToBuild = placement === "bottom" ? bottomItems : items;
    const filteredItemsToBuild = filterPLPItems(itemsToBuild as Entry[]);
    t1 = buildPage(filteredItemsToBuild as Entry[], entry?.fields?.pageId as string);
    $[0] = entry?.fields;
    $[1] = placement;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const children = t1;
  const t2 = placement === "top" && "product-list-page--top";
  const t3 = placement === "bottom" && "product-list-page--bottom";
  let t4;
  if ($[3] !== t2 || $[4] !== t3) {
    t4 = clsx("product-list-page", t2, t3);
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== children || $[7] !== t4) {
    t5 = <div className={t4} data-testid="plp-layout-container">{children}</div>;
    $[6] = children;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
}